import { jsx as _jsx } from "react/jsx-runtime";
import { getObjectHash } from '@iotv/datamodel-core';
import { useEffect, useRef, useState } from 'react';
const debug = process.env.REACT_APP_DEBUG && false;
export const GoogleChartWrapper = ({ data, options, fragmentProps, chartClass }) => {
    "use no memo";
    // Error: Cannot access refs during render
    const chartRef = useRef(null);
    const [chart, setChart] = useState(null);
    const optionsHash = getObjectHash(options);
    const drawChart = () => {
        const target = chartRef.current;
        if (target) {
            let localChart = chart;
            if (!localChart) {
                localChart = new chartClass(target);
                setChart(localChart);
            }
            localChart.draw(data, options);
        }
        else {
            debug && console.log('Graph did not update');
        }
    };
    useEffect(() => {
        debug && console.log(`LineBar used effect on data rows ${data.getNumberOfRows()}. cols ${data.getNumberOfColumns()}`);
        drawChart();
    }, [data]);
    useEffect(() => {
        debug && console.log(`LineBar used effect on optionsHash`);
        setChart(null);
        drawChart();
    }, [optionsHash]);
    return _jsx("div", { ref: chartRef, ...fragmentProps });
};
